import { Escala } from "@/components/ui/controles";
import { useDatos } from "../store/store";
import { encadenar, setDiagAnsweredAt, setEnLista } from "../store/acciones";
import { SeccionLayout, Bloque } from "../componentes/SeccionLayout";
import { CandadoSensibles } from "../componentes/CandadoSensibles";
import { Ejemplo } from "../componentes/Ejemplo";
import { useFotoEnVivo } from "../useFotoEnVivo";
import { fechaCorta, hoyISO, PASOS_IDP, siguienteDiagnostico, TOTAL_IDP } from "./preguntas-diagnostico";

function EscalaLeyenda() {
  return <p className="rounded-md bg-fondo p-3 text-xs text-tinta-suave"><b className="text-tinta">1</b> = no lo he pensado, vive en mi cabeza o no existe · <b className="text-tinta">3</b> = lo tengo más o menos, pero no por escrito ni lo reviso · <b className="text-tinta">5</b> = lo tengo claro, por escrito, y lo reviso</p>;
}

/** Diagnóstico de diseño patrimonial (pág. 4 del cuaderno + pasos 3-5): 24 preguntas de 1 a 5 → IDP /100. Se repite cada trimestre. */
export function Diagnostico() {
  const d = useDatos((x) => x.inputs.diag);
  const apply = useDatos((x) => x.apply);
  const { snapshot } = useFotoEnVivo();
  const idp = snapshot?.idp.score ?? null;
  const pasos = snapshot?.idp.steps ?? [];
  const sig = siguienteDiagnostico(d.answeredAt);
  const contestar = (k: (typeof PASOS_IDP)[number]["k"], i: number, v: number | null) =>
    apply(d.answeredAt ? setEnLista(`diag.${k}`, i, v) : encadenar(setEnLista(`diag.${k}`, i, v), setDiagAnsweredAt(hoyISO())));
  return (
    <SeccionLayout id="diagnostico" intro={<><b className="text-tinta">Contéstalo antes de llenar tus números.</b> Si lo llenas después, ya no mide tu punto de partida. Son {TOTAL_IDP} toques; contesta con honestidad, no con perfección. Lo vuelves a contestar cada trimestre.</>}>
      <CandadoSensibles>
      <EscalaLeyenda />
      {PASOS_IDP.map((p) => {
        const paso = pasos.find((s) => s.key === p.k);
        return (
          <Bloque key={p.k} titulo={p.titulo} ayuda={paso?.legacy ? "Este paso viene de tu Excel de WealthX como promedio; si contestas las preguntas, se usan esas." : undefined}>
            <ol className="flex flex-col gap-5">{p.preguntas.map((q, i) => (
              <li key={i} className="flex flex-col gap-2"><span className="text-sm font-medium">{q}</span><Escala etiqueta={q} valor={d[p.k][i]} onChange={(v) => contestar(p.k, i, v)} /></li>
            ))}</ol>
            {paso?.value !== null && paso?.value !== undefined && <p className="mt-4 text-sm text-tinta-suave">Promedio del paso: <b className="tabular text-tinta">{paso.value.toFixed(1)}</b> de 5</p>}
          </Bloque>
        );
      })}
      {idp !== null && (
        <p className="rounded-md border border-borde bg-white p-4 text-sm">Tu IDP: <b className="tabular text-lg">{Math.round(idp)} / 100</b><br />
          <span className="text-tinta-suave">Promedia solo los pasos contestados. Menos de 50: a la deriva · 50 a 79: tienes piezas, no diseño · 80 a 100: diseño vivo.{d.answeredAt && ` Contestado el ${fechaCorta(d.answeredAt)}`}{sig && ` · el siguiente toca ${sig.vencido ? "ya" : `a partir del ${fechaCorta(sig.fecha)}`}`}.</span>
        </p>
      )}
      <Ejemplo campo="diagnostico" />
      </CandadoSensibles>
    </SeccionLayout>
  );
}
